var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons/faAngleDown";
import { getCategoryCSSClasses } from "./helpers";
import { Item } from "../Item";
export var Category = function (props) {
    var categoryIndex = props.index, children = props.children, title = props.title, isOnlyChild = props.isOnlyChild, isCollapsable = props.isCollapsable, setCurrentCategory = props.setCurrentCategory, currentCategory = props.currentCategory, useAltColors = props.useAltColors;
    var isOpen = currentCategory === categoryIndex;
    var _a = getCategoryCSSClasses(__assign(__assign({}, props), { isOpen: isOpen })), wrapperClass = _a.wrapperClass, innerWrapperClass = _a.innerWrapperClass, buttonTitleClass = _a.buttonTitleClass, buttonWrapperClass = _a.buttonWrapperClass, chevronClass = _a.chevronClass, paragraphTitleClass = _a.paragraphTitleClass, childrenClass = _a.childrenClass;
    return (React.createElement("article", { className: wrapperClass },
        Boolean(title) &&
            (isCollapsable ? (React.createElement("button", { className: buttonTitleClass, type: "button", onClick: function () { return setCurrentCategory(!isOpen ? categoryIndex : null); } },
                React.createElement("span", { className: buttonWrapperClass },
                    React.createElement("span", null, title),
                    React.createElement("span", { className: "md:hidden" },
                        React.createElement(FontAwesomeIcon, { icon: faAngleDown, size: "2x", className: chevronClass }))))) : (React.createElement("p", { className: paragraphTitleClass },
                React.createElement("span", null, title)))),
        React.createElement("div", { className: innerWrapperClass, "data-testid": "inner-wrapper" }, children.map(function (item, index) { return (React.createElement(Item, __assign({}, item, { key: index, className: childrenClass, isOnlyChild: isOnlyChild, useAltColors: useAltColors }))); }))));
};
//# sourceMappingURL=Category.js.map